import React from "react";

const MobileViewContext = React.createContext({});
export default MobileViewContext;
